<h1 mat-dialog-title>
  <span>{{ title }}</span>
</h1>

<div mat-dialog-content>
  <div>{{ message }}</div>
</div>

<div mat-dialog-actions fxLayout="row" fxLayoutAlign="space-between center" class="margin-top">
  <button mat-raised-button color="warn" [mat-dialog-close]="true">
    {{ 'GENERAL.YES' | translate }}
  </button>
  <button mat-raised-button (click)="onCancel()">{{ 'GENERAL.NO' | translate }}</button>
</div>
